import { faDownload, faRedo, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, createStyles, makeStyles } from '@material-ui/core';
import React, { useState, useEffect, Fragment } from 'react';
import { File } from '../../../services/api';
import { isNullOrEmpty } from '../../../utils';
import CircleLoading from '../loading/CircleLoading';

interface Props {
  fileKey: string;
  className?: string;
  rotate?: boolean;
}

export const useStyles = makeStyles((theme) =>
  createStyles({
    rotateBtn: {
      margin: theme.spacing(0.5),
      minWidth: '32px !important',
    },
  }),
);

const Picture: React.FC<Props> = (props) => {
  const { fileKey, className = '', rotate = false } = props;
  const [file, setFile] = useState<any>();
  const [offset, setOffset] = useState<number>(0);
  const [rotation, setRotation] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const { rotateBtn } = useStyles();

  useEffect(() => {
    setRotation(0);
    async function getFile(fileKey: string) {
      const { get } = new File();
      const result = isNullOrEmpty(fileKey) ? '' : await get(fileKey);
      setFile(result == '' ? '' : window.URL.createObjectURL(result));

      setIsLoading(false);
    }
    getFile(fileKey);
  }, []);
  const onImgLoad = (event: any): void => {
    if (rotate && event.clientWidth > event.clientHeight) {
      setOffset((event.clientWidth - event.clientHeight) / 2);
    }
  };

  return (
    <>
      {isLoading && <CircleLoading />}
      {!isNullOrEmpty(file) && (
        <img
          width="100%"
          className={className}
          style={{
            maxWidth: '500px',
            maxHeight: '500px',
            transform: `rotate(${rotation}deg)`,
            margin: `${offset}px 0px`,
          }}
          src={file}
          onLoad={(e) => onImgLoad(e.target)}
        />
      )}
      {!isNullOrEmpty(file) && rotate && (
        <div
          style={{
            direction: 'ltr',
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setRotation(rotation - 90)}
            className={rotateBtn}
          >
            <FontAwesomeIcon icon={faUndo} />
          </Button>
          <Button
            variant="outlined"
            onClick={() => setRotation(rotation + 90)}
            className={rotateBtn}
          >
            <FontAwesomeIcon icon={faRedo} />
          </Button>
        </div>
      )}
    </>
  );
};

export default Picture;
